import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@app/auth.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {   
    const authToken = inject(AuthService).getAuthorizationToken();

    // Clone the request to add the authentication header.
    const newReq = authToken !== undefined && authToken !== null && authToken !== ''
        ? req.clone({ headers: req.headers.set('Authorization', authToken) })
        : req.clone();

    return next(newReq);
}
